var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{ref:'imgRetry',staticClass:"z2-img",attrs:{"src":_vm.src},on:{"error":_vm.errorImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }